import { IBasicData } from "../views/Company/types"

export const DRAWER_WIDTH = 300

export const MESSAGES = {
  required: 'Campo obligatorio *',
  shortRequired: 'Obligatorio*',
  max: 'Longitud sobrepasada maximo :',
  typeError: 'El valor ingresado debe ser: ',
  typeErrorMsg: 'Error data*',
  numberPositive: 'Valor debe ser positivo'
}

export const LIST_PERSON_TYPE: IBasicData[] = [
  {
    id:'1',
    name:'Persona jurídica',
    code:'J'
  },
  {
    id:'2',
    name:'Persona natural',
    code:'N'
  }
]
